export default __webpack_public_path__ + "e9e2cbad06f310c7e2da78b0de38c988.png";